<template>
    <Breadcrumbs main="Interview" title="Interview Process Panel 2" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <interviewProcess />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const interviewProcess = defineAsyncComponent(() => import("@/components/front-office/interview-process-panel-2/index.vue"))
</script>